import {
  IVitalListEmptyEntry,
  IVitalListEntry,
  TRecordConfig,
  TVitalDataResponse,
  TVitalDataSearchItem,
  TVitalSettingsResponse,
} from '../../../types/life-id';
import getGraphData from '../get-graph-data';
import { getDetailRowProps } from '../get-detail-row-props';
import getBadgeProps from '../get-badge-props';

/**
 *
 * @param vitalData
 * @param vitalDataSettings
 * @param config TRecordConfig
 */
export default function temperatureEntry(
  vitalData: TVitalDataResponse | null,
  vitalDataSettings: TVitalSettingsResponse | null,
  config: TRecordConfig,
): IVitalListEntry | IVitalListEmptyEntry {
  const emptyEntry: IVitalListEmptyEntry = {
    isEmpty: true,
    iconSrc: require('../../../assets/svg/icon-temperature.svg').default,
    title: 'life_id.temperature',
  };

  if (!vitalDataSettings || !vitalData || !vitalData.temperature) {
    return emptyEntry;
  }

  const settings = [vitalDataSettings.temperature];
  const lastRecord = vitalData.temperature.lastRecord;

  return {
    ...emptyEntry,
    modalType: 'TEMPERATURE' as const,
    isEmpty: false,
    average: vitalData.temperature.average || '-',
    status: `life_id:status.${lastRecord.status}`,
    ...getBadgeProps(lastRecord.source),
    getDetailRowProps: getDetailRowProps(
      settings,
      config.TEMPERATURE.valueSelectors[0] as keyof TVitalDataSearchItem,
    ),
    summaryChartProps: {
      oneSidedRange: false,
      unit: `units.${config.TEMPERATURE.unit}`,
      value: lastRecord.temperature || '-',
      ...getGraphData(settings, [lastRecord.temperature]),
    },
    urlPart: config.TEMPERATURE.urlPart,
  };
}
